import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import OnboardingButton from './OnboardingButton';
import CardBox from '../kea/CardBox';

export default function OnboardingCard({ card }) {
  const dispatch = useDispatch();
  
  return (
    <Grid item xs={4} className="onboarding-card">
      <CardBox className="onboarding-card__card">
        <div className="onboarding-card__image-container">
          <img className="onboarding-card__image" src={card.image} alt={card.header} />
        </div>
        <p className="onboarding-card__subheader1">{card.header}</p>
        <p className="onboarding-card__card-text">{card.meta}</p>
        <OnboardingButton
          color={card.buttonColor}
          onClick={() => {
            dispatch(card.buttonOnClick());
          }}
          disabled={card.isLoading}
        >
          {card.isLoading ? (
            <>
              <CircularProgress size={20} style={{ color: 'white', marginRight: 8 }} />
              <span className="onboarding-card__button-loading-text">
                {card.loadingText || card.buttonText}
              </span>
            </>
          ) : (
            card.buttonText
          )}
        </OnboardingButton>
      </CardBox>
    </Grid>
  );
}

OnboardingCard.propTypes = {
  card: PropTypes.shape({
    header: PropTypes.string,
    buttonColor: PropTypes.string,
    buttonIcon: PropTypes.string,
    buttonText: PropTypes.string,
    loadingText: PropTypes.string,
    isLoading: PropTypes.bool,
    meta: PropTypes.string,
    buttonOnClick: PropTypes.func,
    step: PropTypes.number,
  }).isRequired,
};
